import React, { useCallback, useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { FolderOpen, LogOut, OctagonX } from "lucide-react";
import { clearAuthToken, getGlobalKillSwitch, setGlobalKillSwitch } from "@/lib/api";
import { toast } from "sonner";

const KillSwitchButton = () => {
  const [active, setActive] = useState(false);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => getGlobalKillSwitch().then((d) => setActive(!!d.active)).catch(() => {}), []);
  useEffect(() => { load(); const t = setInterval(load, 15000); return () => clearInterval(t); }, [load]);

  const toggle = async () => {
    if (active && !window.confirm("Riattivare le esecuzioni reali su tutti i motori?")) return;
    setBusy(true);
    try {
      const d = await setGlobalKillSwitch(!active);
      setActive(!!d.active);
      if (d.active) toast.error("KILL SWITCH ATTIVO", { description: "Ogni apertura reale è bloccata. Le chiusure restano permesse." });
      else toast.success("Esecuzioni reali riattivate");
    } catch { toast.error("Errore kill switch"); }
    finally { setBusy(false); }
  };

  return (
    <Button
      data-testid="kill-switch-btn"
      size="sm"
      variant={active ? "destructive" : "outline"}
      onClick={toggle}
      disabled={busy}
      className={cn("shrink-0 h-8 font-mono text-xs",
        active ? "animate-pulse" : "border-rose-500/40 text-rose-400 hover:bg-rose-500/10 hover:text-rose-300")}
      title={active ? "Trading reale FERMO — clicca per riattivare" : "Blocca all'istante ogni apertura reale su tutti i motori"}
    >
      <OctagonX className="h-3.5 w-3.5 sm:mr-1.5" />
      <span className="hidden sm:inline">{active ? "TRADING FERMO" : "KILL"}</span>
    </Button>
  );
};

const LogoutButton = () => {
  const logout = () => {
    clearAuthToken();
    toast.success("Sessione chiusa su questo dispositivo");
    window.dispatchEvent(new Event("oracle-locked"));
  };
  return (
    <Button
      data-testid="logout-btn"
      size="sm"
      variant="ghost"
      onClick={logout}
      className="shrink-0 h-8 px-2.5 text-muted-foreground hover:text-foreground"
      title="Esci: rimuove la sessione da questo dispositivo e torna alla schermata di blocco"
    >
      <LogOut className="h-4 w-4" />
    </Button>
  );
};

export const Topbar = ({ section, onOpenConfigs }) => (
  <header
    data-testid="app-topbar"
    className="sticky top-0 z-40 h-14 border-b border-border bg-background/90 backdrop-blur supports-[backdrop-filter]:bg-background/80"
  >
    <div className="w-full mx-auto h-full px-4 md:px-6 flex items-center gap-3">
      <h1 className="font-display text-[22px] md:text-2xl leading-none tracking-tight text-foreground">
        Oracle<span className="text-emerald-500">.</span>
      </h1>
      <span className="hidden md:inline font-mono text-[10px] uppercase tracking-[0.24em] text-muted-foreground/70 mt-0.5">
        quant desk autonomo
      </span>
      <div className="ml-auto flex items-center gap-2">
        {section === "ctrader" && onOpenConfigs && (
          <Button
            data-testid="open-saved-configs-drawer"
            size="sm"
            variant="outline"
            onClick={onOpenConfigs}
            className="shrink-0 h-8 text-xs"
          >
            <FolderOpen className="h-3.5 w-3.5 sm:mr-1.5" />
            <span className="hidden sm:inline">Configurazioni</span>
          </Button>
        )}
        <KillSwitchButton />
        <LogoutButton />
      </div>
    </div>
  </header>
);
